import React from 'react';

const Categories = () => <h2 style={{ margin: '20px' }}>Under construction</h2>;

export default Categories;
